import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class WorkflowInstanceService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const r = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return { success: true, data: r.data || [], pagination: r.pagination || {}, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to list workflow instances'); }
    }

    async getById(id) {
        try {
            const r = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: r.data, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to fetch workflow instance'); }
    }

    async start(payload) {
        try {
            const r = await this.api.start(payload);
            return { success: true, data: r.data, message: r.message || 'Workflow başlatıldı' };
        } catch (e) { throw this._handle(e, 'Failed to start workflow instance'); }
    }

    async cancel(id, payload) {
        try {
            const r = await this.api.cancel(id, payload);
            return { success: true, data: r.data, message: r.message || 'Workflow iptal edildi' };
        } catch (e) { throw this._handle(e, 'Failed to cancel workflow instance'); }
    }

    async suspend(id, payload) {
        try {
            const r = await this.api.suspend(id, payload);
            return { success: true, data: r.data, message: r.message || 'Workflow askıya alındı' };
        } catch (e) { throw this._handle(e, 'Failed to suspend workflow instance'); }
    }

    async resume(id, payload) {
        try {
            const r = await this.api.resume(id, payload);
            return { success: true, data: r.data, message: r.message || 'Workflow devam ediyor' };
        } catch (e) { throw this._handle(e, 'Failed to resume workflow instance'); }
    }

    async injectApprovers(id, payload) {
        try {
            const r = await this.api.injectApprovers(id, payload);
            return { success: true, data: r.data, message: r.message || 'Onaycılar eklendi' };
        } catch (e) { throw this._handle(e, 'Failed to inject approvers'); }
    }

    async emergencyComplete(id, payload) {
        try {
            const r = await this.api.emergencyComplete(id, payload);
            return { success: true, data: r.data, message: r.message || 'Workflow acil tamamlandı' };
        } catch (e) { throw this._handle(e, 'Failed to emergency-complete workflow'); }
    }

    _handle(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
